import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <CFLink href="https://goo.gl/maps/J4FcXJmR3zsqV8GQ8">
              <CFImage src={mobileMap} w="100%" alt="The Hide Out Diner Map" />
            </CFLink>
          </MobileScreen>
          <DefaultScreen>
            <CFLink href="https://goo.gl/maps/J4FcXJmR3zsqV8GQ8">
              <CFImage
                src={locationMap}
                w="100%"
                alt="The Hide Out Diner Map"
              />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
